import API_CONFIG from "../Configuration/apiConfig";

const S3_BASE_URL = `${API_CONFIG.SERVICE_URL}${API_CONFIG.ENDPOINTS.S3.PRESIGNED_URL}`;
const S3_BUCKET = API_CONFIG.S3_BUCKETS.IMAGES;

const urlCache = new Map();

const CACHE_TTL = 55 * 60 * 1000; 

export async function generatePresignedUrl(s3Path, { month, year } = {}) {
  const cacheKey = `${s3Path}_${month ?? ""}_${year ?? ""}`;

  const cached = urlCache.get(cacheKey);

  if (cached && Date.now() < cached.expiresAt) {
    return cached.url;
  }

  const params = new URLSearchParams({
    fileName: s3Path,
    bucketName: S3_BUCKET,
    operation: "download",
  });

  if (month != null) params.set("month", month);
  if (year != null) params.set("year", year);

  try {
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 5000);

    const response = await fetch(`${S3_BASE_URL}?${params}`, {
      signal: controller.signal,
    });

    clearTimeout(timeout);

    if (!response.ok) throw new Error("Failed to fetch presigned URL");

    const url = (await response.text()).trim();

    urlCache.set(cacheKey, {
      url,
      expiresAt: Date.now() + CACHE_TTL,
    });

    return url;
  } catch (err) {
    console.error("Failed to generate presigned URL:", err);
    return null;
  }
}

export function clearPresignedUrlCache() {
  urlCache.clear();
}

export async function downloadImageAsFile(url, filename) {
  if (!url) return;
  try {
    const response = await fetch(url, { mode: "cors", cache: "no-cache" });
    if (!response.ok) throw new Error("Failed to fetch image for download");
    const blob = await response.blob();
    const blobUrl = window.URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = blobUrl;
    link.download = filename;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(blobUrl);
  } catch (err) {
    console.warn("Direct download failed, falling back to new tab:", err);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    link.target = "_blank";
    link.rel = "noopener noreferrer";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}